function range(start: number, length: number) {
  return Array.from({ length }, (_, i) => i + start);
}

function shuffle(a: any[]) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const getRandomNums = (eventLen: number, imgLen = 10) => {
  const arr = [];
  const imgs = shuffle(range(1, imgLen));
  const digits = range(1, eventLen + 1).map((i) => (i > imgLen ? i % 10 : i));
  range(0, eventLen).forEach(() => {
    const rand = Math.floor(Math.random() * (digits.length - 1));
    const [d] = digits.splice(rand, 1);
    if (arr && arr[arr.length - 1] === d) {
      if (arr[0] === d) {
        arr.splice(1, 0, d);
      } else {
        arr.unshift(d);
      }
    } else {
      arr.push(d);
    }
  });
  return arr.map((i) => imgs[i - 1]);
};
